/**
 * PWA INITIALIZATION
 * ==================
 * Inicializa o PWA: Service Worker, Install Prompt, etc
 */

import { registerServiceWorker } from './utils/sw-register';

// Registra o Service Worker automaticamente
registerServiceWorker({
  onSuccess: registration => {
    console.log('✅ PWA: Service Worker registered successfully');
  },
  onUpdate: registration => {
    console.log('🔄 PWA: New version available');
    // Mostra notificação de atualização disponível
    if (confirm('Nova versão disponível! Deseja atualizar agora?')) {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    }
  },
  onOffline: () => {
    console.log('📡 PWA: App is now offline');
  },
  onOnline: () => {
    console.log('📡 PWA: App is back online');
  },
});

// Log PWA status
if (window.matchMedia('(display-mode: standalone)').matches) {
  console.log('📱 PWA: Running as installed app');
} else {
  console.log('🌐 PWA: Running in browser');
}

export {};
